import Sidebar from '../../components/sidebar/Sidebar'
import Widget from '../../components/widget/Widget'
import InventoryAlertTable from '../inventory/InventoryAlertTable'
import './home.css'

const Home = () => {
    const widgetTypes = [
        'employee',
        'total-product',
        'low-product',
        'total-cost',
        'total-retail',
    ];
    return (
        <div className='home'>
            <Sidebar />
            <div className="homeContainer">
                <div className="widgets">
                    {widgetTypes.map((type) => (
                        <Widget key={type} type={type} />
                    ))}
                </div>
                <div className="db-ls-container">
                    <div className='db-ls-div'>
                        <h4 className='db-ls-title'>Low Stock Products</h4>
                    </div>
                    <InventoryAlertTable />
                </div>
            </div>
        </div>
    )
}

export default Home;